import { takeLatest } from 'redux-saga/effects'
import { EDIT_TEMPLATE_SAGA } from 'src/store/types/templatePhrases'
import editTemplate from './editTemplate'

export function* editTemplateSaga() {
  yield takeLatest(EDIT_TEMPLATE_SAGA, editTemplate)
}
